import React from 'react'

import { Box, Text, useBreakpoint } from '@factorialco/deprecated-design-system'

import NumberBadge from './NumberBadge'

interface ReferralStepProps {
  number: number
  title: string
  description: string
}

const ReferralStep = ({ number, title, description }: ReferralStepProps) => {
  const { isMobile } = useBreakpoint()

  return (
    <Box flexDirection="column" alignItems="flexStart" gap="s16">
      <NumberBadge number={number} />
      <Box maxWidth={isMobile ? 'full' : 's400'} gap="s4">
        <Text weight="semibold" size="300" color="black">
          {title}
        </Text>
        <Text size={'300'} className="text-f1-foreground-secondary">
          {description}
        </Text>
      </Box>
    </Box>
  )
}

export default ReferralStep
